import { useEffect, useState } from 'react'
import { seatbeltSettings } from '@which/seatbelt'

import { debounce } from '../../../../shared/utils/debounce'

const MOBILE_BREAKPOINT = parseInt(seatbeltSettings.breakpoints.SbBreakpointsLarge) - 1

export const useProductListingPageOverlayFilters = () => {
  const [isOverlayFiltersDisplayed, setIsOverlayFiltersDisplayed] = useState<boolean>(false)

  useEffect(() => {
    const debouncedResizeHandler = debounce((e: Event) => {
      const { innerWidth } = e.target as Window
      innerWidth > MOBILE_BREAKPOINT && setIsOverlayFiltersDisplayed(false)
    }, 100)

    if (isOverlayFiltersDisplayed) {
      document.body.style.overflow = 'hidden'
      document.body.style.touchAction = 'none'
      window.addEventListener('resize', debouncedResizeHandler)
    } else {
      document.body.style.overflow = 'unset'
      document.body.style.touchAction = 'unset'
      window.removeEventListener('resize', debouncedResizeHandler)
    }

    return () => {
      window.removeEventListener('resize', debouncedResizeHandler)
      document.body.style.overflow = 'unset'
      document.body.style.touchAction = 'unset'
    }
  }, [isOverlayFiltersDisplayed])

  return { setIsOverlayFiltersDisplayed, isOverlayFiltersDisplayed }
}
